import { Home, BookOpen, MessageCircle } from 'lucide-react'

export type TabId = 'home' | 'help' | 'troubleshooting' | 'chat'

const TABS: { id: TabId; label: string; icon: React.ElementType }[] = [
  { id: 'home', label: 'Home', icon: Home },
  { id: 'chat', label: 'Messages', icon: MessageCircle },
  { id: 'help', label: 'Help', icon: BookOpen },
]

interface WidgetTabBarProps {
  activeTab: TabId
  onTabChange: (tab: TabId) => void
}

export function WidgetTabBar({ activeTab, onTabChange }: WidgetTabBarProps) {
  return (
    <div className="border-t border-border bg-card flex-shrink-0 flex">
      {TABS.map((tab) => {
        const isActive = activeTab === tab.id
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex-1 flex flex-col items-center gap-1 py-2.5 text-xs transition-colors border-t-2 ${
              isActive
                ? 'text-primary border-primary'
                : 'text-muted-foreground hover:text-foreground border-transparent'
            }`}
          >
            <tab.icon className="w-5 h-5" />
            <span className="font-medium">{tab.label}</span>
          </button>
        )
      })}
    </div>
  )
}
